module.exports = __webpack_public_path__ + "static/media/lg57.79df67fe.png";